import productDisplayLandscapeImg from "../../assets/img/product-gg-display-landscape.png"
import productDisplayLandscapeImgWebp from "../../assets/img/product-gg-display-landscape.webp"

const Benefits = () => (
    <section id="benefits" className="gg-bg-solid-green-light">
        <div className="container-fluid">
            <div className="row justify-content-center align-items-center py-5">
                <div className="col-xxl-8 col-lg-10 col-11 py-5 px-xxl-4 px-3 gg-bg-solid-blue gg-border-radius">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-xxl-4 col-lg-5 col-md-5 col-12 align-items-center text-center">
                            <picture>
                                <source srcSet={productDisplayLandscapeImgWebp} type="image/webp" />
                                <img className="img-fluid gg-border-radius" src={productDisplayLandscapeImg} loading="lazy"/>
                            </picture>                            
                        </div>
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-white text-md-start text-center">
                            <h3 className="fw-bold">Are You Tired of Constant Fatigue, Frustrating Blood Sugar Spikes, and Endless Food Restrictions?</h3>
                            <p>Take your life back naturally with GlucoGen<sup>17</sup> Naturals.</p>
                            <p>Crafted by Dr. Hart, this original blend harnesses powerful natural ingredients clinically proven to help support your body's natural ability to regulate blood sugar. Feeling better shouldn’t come at the cost of joy, freedom, or peace of mind. There’s a more balanced way forward.</p>
                            <p className="gg-yellow">GlucoGen<sup>17</sup> Naturals targets the underlying factor, resetting your metabolism and clearing toxic barriers that prevent healthy insulin function.</p>
                            <p>Click below to reclaim your health today.</p>
                            <a href="#countdown" className="text-decoration-none btn gg-button-buy-yellow gg-bigger-button fw-bold text-uppercase gtm-nav-btn" data-gtm-label="GlucoGen - Benefits Section - Order Now Button - Go to Buy">Order Now</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Benefits;